module.exports = __webpack_public_path__ + "img/20_116.63117c80.png";